<template>
  <div class="aPullc" @click="toApp()">
    <img src="./images/bg.png" alt="" />
  </div>
</template>
<script>
export default {
  name: 'UserRelation',
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    toApp() {
      this.$confirm({
        content: '請打開nicee應用參加我們的活動',
        title: '提示',
        showCancelButton: false,
        confirmButtonText: '確定',
        closeOnClickModal: false
      }).then(() => {
        try {
          const url =
            this.$util.nativeType === 'iOS'
              ? 'h5invokeapp:///aPullc'
              : 'nicee://main/?aPullc';
          window.location.href = url;
        } catch (error) {
          this.$util.jumpAppStore();
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.aPullc {
  width: 100%;
  display: flex;
  justify-content: center;
  img {
    // width: 100%;
    max-width: 100%;
    height: auto;
  }
}
</style>
